var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _path, _rect43, _rect44, _rect45, _rect46, _rect47, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard4Mob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 200,
    viewBox: "0 0 236 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 59.4707,
    width: 90.3756,
    height: 81.0586,
    rx: 5.61711,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3146,
    y: 68.7881,
    width: 49.3805,
    height: 7.45366,
    rx: 3.72683,
    fill: "#A3BBD1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7487,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7487,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9975,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9975,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.178,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54.178,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4268,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4268,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6073,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6073,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7878,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7878,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0366,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0366,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4268,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6073,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7878,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0366,
    y: 86.4905,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7487,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9975,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 54.178,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4268,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6073,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7878,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0366,
    y: 96.7393,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7487,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9975,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 54.178,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#003A70"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4268,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6073,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7878,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0366,
    y: 106.988,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7487,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9975,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 54.178,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4268,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6073,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7878,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0366,
    y: 117.237,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7487,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9975,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 54.178,
    y: 126.554,
    width: 4.65854,
    height: 4.65854,
    rx: 1.86342,
    fill: "#A3BBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5111 68.1238H40.9418V67.5546C40.9418 67.2415 40.6857 66.9854 40.3726 66.9854C40.0595 66.9854 39.8034 67.2415 39.8034 67.5546V68.1238H35.2495V67.5546C35.2495 67.2415 34.9934 66.9854 34.6803 66.9854C34.3672 66.9854 34.1111 67.2415 34.1111 67.5546V68.1238H33.5418C32.91 68.1238 32.4091 68.6361 32.4091 69.2623L32.4034 77.2315C32.4034 77.8577 32.91 78.37 33.5418 78.37H41.5111C42.1372 78.37 42.6495 77.8577 42.6495 77.2315V69.2623C42.6495 68.6361 42.1372 68.1238 41.5111 68.1238ZM41.5111 76.6623C41.5111 76.9754 41.2549 77.2315 40.9418 77.2315H34.1111C33.798 77.2315 33.5418 76.9754 33.5418 76.6623V70.97H41.5111V76.6623ZM34.6803 72.1084H35.8188V73.2469H34.6803V72.1084ZM36.9572 72.1084H38.0957V73.2469H36.9572V72.1084ZM39.2341 72.1084H40.3726V73.2469H39.2341V72.1084Z",
    fill: "#003A70"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 123.124,
    y: 59.4709,
    width: 90.3756,
    height: 81.0586,
    rx: 5.61711,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 152.939,
    y: 68.7881,
    width: 49.3805,
    height: 7.45366,
    rx: 3.72683,
    fill: "#A3BBD1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 132.442,
    y: 101.398,
    width: 27.0195,
    height: 7.45366,
    rx: 3.72683,
    fill: "#A3BBD1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 132.442,
    y: 101.398,
    width: 29.8146,
    height: 7.45366,
    rx: 3.72683,
    fill: "#A3BBD1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 172.505,
    y: 101.398,
    width: 29.8146,
    height: 7.45366,
    rx: 3.72683,
    fill: "#A3BBD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.151 66.9856C135.009 66.9856 132.464 69.5358 132.464 72.6779C132.464 75.8201 135.009 78.3702 138.151 78.3702C141.299 78.3702 143.849 75.8201 143.849 72.6779C143.849 69.5358 141.299 66.9856 138.151 66.9856ZM138.156 77.2318C135.64 77.2318 133.603 75.1939 133.603 72.6779C133.603 70.1619 135.64 68.1241 138.156 68.1241C140.672 68.1241 142.71 70.1619 142.71 72.6779C142.71 75.1939 140.672 77.2318 138.156 77.2318ZM138.031 69.8318H137.997C137.769 69.8318 137.587 70.0139 137.587 70.2416V72.9284C137.587 73.1276 137.69 73.3154 137.866 73.4179L140.228 74.8353C140.422 74.9491 140.672 74.8922 140.786 74.6987C140.906 74.5051 140.843 74.249 140.644 74.1351L138.441 72.8259V70.2416C138.441 70.0139 138.259 69.8318 138.031 69.8318V69.8318Z",
    fill: "#003A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.424 97.6723C149.596 97.4994 149.596 97.22 149.424 97.0471L147.388 95.012C147.215 94.8391 146.936 94.8391 146.763 95.012L144.728 97.0471C144.555 97.22 144.555 97.4994 144.728 97.6723C144.901 97.8452 145.18 97.8452 145.353 97.6723L147.078 95.952L148.798 97.6723C148.971 97.8452 149.255 97.8408 149.424 97.6723V97.6723Z",
    fill: "#003A70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.735 113.509C144.562 113.682 144.562 113.962 144.735 114.135L146.77 116.17C146.943 116.343 147.222 116.343 147.395 116.17L149.43 114.135C149.603 113.962 149.603 113.682 149.43 113.509C149.257 113.336 148.978 113.336 148.805 113.509L147.08 115.23L145.36 113.509C145.187 113.336 144.903 113.341 144.735 113.509V113.509Z",
    fill: "#003A70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.485 97.6723C189.658 97.4994 189.658 97.22 189.485 97.0471L187.45 95.012C187.277 94.8391 186.997 94.8391 186.824 95.012L184.789 97.0471C184.616 97.22 184.616 97.4994 184.789 97.6723C184.962 97.8452 185.242 97.8452 185.415 97.6723L187.139 95.952L188.86 97.6723C189.033 97.8452 189.316 97.8408 189.485 97.6723V97.6723Z",
    fill: "#003A70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.796 113.509C184.623 113.682 184.623 113.962 184.796 114.135L186.831 116.17C187.004 116.343 187.283 116.343 187.456 116.17L189.491 114.135C189.664 113.962 189.664 113.682 189.491 113.509C189.318 113.336 189.039 113.336 188.866 113.509L187.141 115.23L185.421 113.509C185.248 113.336 184.964 113.341 184.796 113.509V113.509Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4Mob);
export default __webpack_public_path__ + "static/media/card4_mob.91a5f39ce13319b3ebde5efd79c3550c.svg";
export { ForwardRef as ReactComponent };